// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_jd-0";